import { ModSettable } from "ixfx/modulation.js";
import { TimingSourceFactory } from '../types';
import { ModulationTimerFactory } from "./timer";
import * as Flow from "ixfx/flow.js";
import { interpolate } from "ixfx/numbers.js";
import { AnimationAtom, AnimationThing } from './types';



export const together = (f: ModulationTimerFactory, elements: Array<AnimationThing | AnimationAtom>): AnimationThing => {
  let timer: Flow.ModulationTimer | undefined;
  let started = false;

  const start = () => {
    timer = f();
    started = true;
  }

  const tick = () => {
    if (!timer) start();
    if (!timer) return;
    const t = timer.elapsed;
    //console.log(`t: ${ t } done: ${ timer.isDone }`)
    for (const el of elements) {
      el.tick(t)
    }
  }

  const reset = () => {
    timer = undefined;
    started = false;
    for (const el of elements) {
      if (`reset` in el) {
        el.reset();
      }
    }
  }
  return {
    tick, reset, start,
    get isDone() {
      if (timer === undefined) return true;
      return timer.isDone;
    },
    get hasStarted() {
      return started;
    }
  }
}